export default {
    'Invoices': 'Factures',
    'Date': 'Date',
    'Description': 'Description',
    'Cost': 'Coût',
    'Invoice': 'Facture',
    'TEST': 'TEST',
    'Proceed to payment': 'Procéder au paiement'
}